import { render } from "./MediaByIndex.vue?vue&type=template&id=34030cf4&scoped=true"
import script from "./MediaByIndex.vue?vue&type=script&lang=js"
export * from "./MediaByIndex.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-34030cf4"

export default script